/* eslint-disable no-restricted-globals */
import * as types from './action-types';
import * as userAccountApi from '../api/user-account-api';
import * as apiResponseMessages from './api-response-messages';
import * as dataFormatHelper from './helpers/data-format-helper';
import * as messageHelper from './helpers/message-helper';
import { beginApiCall, apiCallError } from './api-status-actions';
import { formMessageConstants } from '../../components/utils/constants/form-message-constants';
import GTMUserActions from '../../components/common/utility/GTMUserActions';

export function loadSSOUpgradeToOneClubFormDataSuccess(ssoUpgradeToOneClubFormData) {
    return { type: types.LOAD_UPGRADE_TO_ONE_CLUB_FORM_DATA_SUCCESS, ssoUpgradeToOneClubFormData };
}

export function loadSSOUpgradeToOneClubFormDataError() {
    return { type: types.LOAD_UPGRADE_TO_ONE_CLUB_FORM_DATA_ERROR };
}

export function upgradeToTicketingAccountSuccess(accountUpgradeMessages) {
    return { type: types.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESS, accountUpgradeMessages };
}

export function upgradeToTicketingAccountError(accountUpgradeMessages) {
    return { type: types.UPGRADE_TO_TICKETING_ACCOUNT_ERROR, accountUpgradeMessages };
}

export function updateOneClubMembershipError(oneClubMembershipUpdateMessages) {
    return { type: types.UPDATE_ONE_CLUB_MEMBERSHIP_ERROR, oneClubMembershipUpdateMessages };
}

export function updateOneClubMembershipSuccess(oneClubMembershipUpdateMessages) {
    return { type: types.UPDATE_ONE_CLUB_MEMBERSHIP_SUCCESS, oneClubMembershipUpdateMessages };
}

export function updatePrivacyPolicyAndTermsAndConditionsError(privacyPolicyAndTermsUpdateMessages) {
    return { type: types.UPDATE_OPTINS_ERROR, privacyPolicyAndTermsUpdateMessages };
}

export function updatePrivacyPolicyAndTermsAndConditionsSuccess(privacyPolicyAndTermsUpdateMessages) {
    return { type: types.UPDATE_OPTINS_SUCCESS, privacyPolicyAndTermsUpdateMessages };
}

export function resetUpgradeAccountFormState() {
    return { type: types.RESET_UPGRADE_ACCOUNT_FORM };
}

export function loadSSOUpgradeToOneClubFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getSSOUpgradeToOneClubFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSOUpgradeToOneClubFormDataError());
                    return;
                }
                dispatch(loadSSOUpgradeToOneClubFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSOUpgradeToOneClubFormDataError());
                throw error;
            });
    };
}

export function upgradeToTicketingAccount(ssoDomain, userDetails, currentUser, callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];

    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateUserDetailsPost(dataFormatHelper.getFormattedUserDataForUpgradeToTicketingAccount(ssoDomain, currentUser, userDetails), callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(upgradeToTicketingAccountError(serverErrorMessages));
                    return;
                }
                dispatch(upgradeToTicketingAccountSuccess([apiResponseMessages.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(upgradeToTicketingAccountError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function upgradeToOneClubAccount(userDetails, currentUser, callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateUserDetailsPost(dataFormatHelper.getFormattedUserDataForUpgradeToOneClubAccount(currentUser, userDetails), callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(upgradeToTicketingAccountError(serverErrorMessages));
                    return;
                }
                dispatch(upgradeToTicketingAccountSuccess([apiResponseMessages.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(upgradeToTicketingAccountError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function upgradeBallotSummaryAccount(userDetails, currentUser, callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];

    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateUserDetailsPost(dataFormatHelper.getBallotFormattedUserDetailsData(userDetails, currentUser), callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(upgradeToTicketingAccountError(serverErrorMessages));
                    return;
                }
                dispatch(upgradeToTicketingAccountSuccess([apiResponseMessages.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(upgradeToTicketingAccountError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function joinOneClub(callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];

    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateOneClubMembershipStatus(callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(updateOneClubMembershipError(serverErrorMessages));
                    return;
                }
                GTMUserActions.trackJoinTheOneClubAction();
                dispatch(updateOneClubMembershipSuccess([apiResponseMessages.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(updateOneClubMembershipError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function agreePrivacyPolicyAndTermsAndCoditions(callbackUrl, agreePrivaciPolicy, agreeTermsAndConditions) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];

    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.agreeToPrivacyPolicyAndTermsAndConditions(callbackUrl, agreePrivaciPolicy, agreeTermsAndConditions)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(updatePrivacyPolicyAndTermsAndConditionsError(serverErrorMessages));
                    return;
                }
                dispatch(updatePrivacyPolicyAndTermsAndConditionsSuccess([apiResponseMessages.UPDATE_USER_DETAILS_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(updatePrivacyPolicyAndTermsAndConditionsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function addMasterCardMembershipToUser(callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];

    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.addMasterCardMembership(callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(upgradeToTicketingAccountError(serverErrorMessages));
                    return;
                }
                dispatch(upgradeToTicketingAccountSuccess([apiResponseMessages.UPDATE_USER_DETAILS_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(upgradeToTicketingAccountError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}
